import React from 'react';
import Styled from 'styled-components';
import {winProbabilityBand} from './opportunityStage';

// The colour for a win probability (stored 0–1), single-sourced from the win-probability band palette so a
// circle and its % label always match.
export function winProbabilityColour(winChance: number | null | undefined): string {
	return winProbabilityBand(winChance).color;
}

const Dot = Styled.span<{$colour: string}>`
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	flex-shrink: 0;
	background-color: ${props => props.$colour};
`;

// A small colour-coded win-probability indicator dot. `colour` defaults to the band colour for `value`.
export const WinProbabilityCircle = ({value, colour}: {value: number | null | undefined; colour?: string}): JSX.Element => (
	<Dot $colour={colour ?? winProbabilityColour(value)} data-cy="win-dot" />
);
